import type { RouteObject } from "react-router-dom";

import { StatusScreen } from "./StatusScreen";

/** Discovered by 06b's `router.tsx`. `:migrationId` matches `stageRoute.pathForStage(id, "status")`. */
export const routes: RouteObject[] = [{ path: "/migrations/:migrationId/status", element: <StatusScreen /> }];
